<div class="users-section">
    <div class="section-header">
        <span class="section-title">
            {{ 'users.title' | translate }}
        </span>
        <button class="btn-add" *ngIf="supervisor && !showCreateForm" (click)="createDepartmentUser()">
            <i class="fa fa-plus"></i>
        </button>
    </div>

    <div *ngIf="showCreateForm" class="create-form">
        <department-user-details (formClosed)="onFormClosed()"></department-user-details>
    </div>

    <div class="user-list">
        <div class="user-row" *ngFor="let departmentUser of departmentUsers | async">
            <span class="user-info">
                {{ userLabel(departmentUser) }}
            </span>
            <button class="btn-remove" *ngIf="supervisor" (click)="removeDepartmentUser(departmentUser)">
                <span class="material-icons-outlined">cancel</span>
            </button>
        </div>
    </div>
</div>
